import React from "react";

import cover from "../images/primary_pack.png";

export default function PrimaryPackPage() {
  return (
    <section className="section content">
      <h3 className="title is-3">小學教材套</h3>
      <p>
        <a
          href="https://drive.google.com/drive/folders/1j86uGMGi9KxKX-gH1G-f-a2uNGYDEia4"
          target="_blank"
          rel="noreferrer"
        >
          <button className="button is-info">按此下載整套教材</button>
        </a>
      </p>
      <p>
        <a
          href="https://drive.google.com/file/d/1qoXSQRBXAfrCcYkfe9r77ZI3Snaczfz4/view"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={cover}
            style={{ maxWidth: "70vw" }}
            title="PDF 下載"
            alt="PDF 下載"
          ></img>
        </a>
      </p>
    </section>
  );
}
